/**
 * API configuration.
 *
 * Central place for base URL, timeouts and default headers used by the
 * (future) HTTP client layer in `src/api`. No requests are performed here.
 */
import { env } from './env'

export const apiConfig = {
  baseUrl: env.apiUrl,
  timeoutMs: 30_000,
  defaultHeaders: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
} as const

export type ApiConfig = typeof apiConfig
